export enum EventValidationAction {
    Store,
    StoreDiscount,
    StoreSubevent,
    Update,
    UpdateSubevent,
}
